module.exports = __webpack_public_path__ + "assets/8bf3acf7f01f57decc3eb3cf41984f29.png";